import imageCompression from 'browser-image-compression';

/**
 * Create a thumbnail from an image file
 * Optimized for display purposes only
 */
export const createThumbnail = async (file, maxWidth = 400, maxHeight = 400, quality = 0.7) => {
  const options = {
    maxSizeMB: 0.1, // Very small for thumbnail
    maxWidthOrHeight: Math.max(maxWidth, maxHeight),
    useWebWorker: true,
    fileType: 'image/jpeg',
    initialQuality: quality,
  };

  try {
    const thumbnail = await imageCompression(file, options);
    console.log(`Created thumbnail: ${(thumbnail.size / 1024).toFixed(2)}KB`);
    return thumbnail;
  } catch (error) {
    console.error('Thumbnail creation error:', error);
    // Return original file if thumbnail creation fails
    return file;
  }
};

